import { render, staticRenderFns } from "./systemd.vue?vue&type=template&id=01036629&scoped=true&"
import script from "./systemd.vue?vue&type=script&lang=js&"
export * from "./systemd.vue?vue&type=script&lang=js&"
import style0 from "./systemd.vue?vue&type=style&index=0&id=01036629&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../@vue-modules/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01036629",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../@vue-modules/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
